/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import {
  Chart,
  BarSeries,
  ArgumentAxis,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation } from '@devexpress/dx-react-chart';
import { Fragment } from 'react';
import '../../../css/bargraph.css';
import { TimesheetTable } from './TimesheetTable';
import { ContentContainer } from '../../Containers/ContentContainer';
import {
  computeTotalHours,
  formatData,
  getDates,
  getOverallTotal,
} from '../../../utilities/totalHoursData';
import { sortByCheckInDate } from '../../../utilities/sortBy';

const style = {
  px: 10,
  mb: 2,
  pt: 5,
};

const totalStyle = {
  height: '3rem',
  width: '100%',
  bgcolor: '#84d8c5',
  borderRadius: '5px',
};

const totalHrsStyle = {
  position: 'absolute',
  zIndex: '1',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '1.4rem',
  fontWeight: '600',
};

const subs = {
  fontWeight: '500',
  fontSize: '12px',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#828282',
};

const getPath = (x, width, y, y1) => `M ${x} ${y1} 
   L ${width + x} ${y1}
   L ${width + x}  ${y} 
   L ${x + width / 2} ${y} 
   L ${x}  ${y} 
   Z`;

const labelStyle = { fill: '#FFF', fontSize: '14px' };

const BarWithLabel = ({
  arg,
  barWidth,
  maxBarWidth,
  val,
  startVal,
  color,
  value,
  style,
}) => {
  const width = maxBarWidth * barWidth;
  return (
    <Fragment>
      <path
        d={getPath(arg - width / 2, width, val, startVal)}
        fill={color}
        style={style}
      />
      <Chart.Label
        x={arg}
        y={val - 15}
        dominantBaseline="middle"
        textAnchor="middle"
        style={labelStyle}
      >
        {value}
      </Chart.Label>
    </Fragment>
  );
};

export const CutOffTable = (props) => {
  const dateFormat = 'dd MMM yyyy';
  const data = sortByCheckInDate(props.data);
  const today = format(new Date(), dateFormat);
  const dates = getDates(data);
  const timesheetData = formatData(data);
  const combinedData = computeTotalHours(timesheetData);
  const total = getOverallTotal(data);
  const cleanData = combinedData;

  return (
    <>
      <ContentContainer style={style}>
        {cleanData.length !== 0 ? (
          <Chart height={200} data={cleanData.reverse()}>
            <ArgumentAxis indentFromAxis={5} showTicks={false} />
            <BarSeries
              color="#84d8c5"
              barWidth={1.1}
              valueField="hours"
              argumentField="date"
              pointComponent={BarWithLabel}
            />
            <Animation />
          </Chart>
        ) : (
          <Typography align="center" variant="subtitle1" sx={{ mt: 2 }}>
            No Data
          </Typography>
        )}
        <Box
          sx={{
            width: '100%',
            alignSelf: 'center',
            my: '1rem',
            position: 'relative',
          }}
        >
          <Typography sx={totalHrsStyle}>
            {Math.floor(total * 1000) / 1000} HOURS
          </Typography>
          <Box sx={totalStyle} />
        </Box>
        <Typography sx={subs}>
          {(() => {
            if (dates.length === 0) {
              return String('No time record for this cutoff');
            } else if (dates.length === 1) {
              return String('Daily time record for ' + dates[0]);
            } else {
              return String(
                'Daily time record from ' +
                  dates[dates.length - 1] +
                  ' to ' +
                  dates[0]
              );
            }
          })()}
          {console.log(data)}
        </Typography>
      </ContentContainer>
      <TimesheetTable isCutoffTab={true} data={data} />
    </>
  );
};
